import { createContext } from 'react';

export type RequestExecutorsContextType = {
    updateActualAppointment: boolean;
    addActualAppointment: boolean;
};

export const RequestExecutorsContext = createContext<RequestExecutorsContextType>({} as RequestExecutorsContextType);
